import React, {useEffect, useState} from 'react';
import {isPRD} from '../../../utlis/vars';
import ErrorText from '../@Text/ErrorText/ErrorText';
import {FmComponent} from '../types/types';
import './style.scss';

interface IProgressBar extends FmComponent {
  progress: number;
  maxProgress?: number;
  wrapperStyle?: React.CSSProperties;
  barStyle?: React.CSSProperties;
  bgStyle?: React.CSSProperties;
}

const ProgressBar = ({
                       progress,
                       maxProgress = 4,
                       id,
                       className,
                       'data-testid': dataTestId,
                       wrapperStyle,
                       barStyle,
                       bgStyle
                     }: IProgressBar): React.ReactElement => {
  const [error, setError] = useState('');

  useEffect(() => {
    if (progress > maxProgress) setError("Progress can't be larger than maximum progress");
    else setError('');
  }, []);

  return error ? (
    <ErrorText data-testid="fm-progress-bar-error">{error}</ErrorText>
  ) : (
    <div
      id={id}
      style={wrapperStyle}
      data-testid={isPRD ? undefined : dataTestId}
      className={`fm-progress-bar${className ? ` ${className}` : ''}`}
      data-progress={isPRD ? undefined : progress}
      data-max-progress={isPRD ? undefined : maxProgress}
      data-progress-ratio={isPRD ? undefined : progress / maxProgress}
    >
      <div
        className="fm-progress-green"
        style={{...barStyle, width: `${(progress / maxProgress) * 100}%`}}
      ></div>
      <div className="fm-progress-gray" style={bgStyle}></div>
    </div>
  );
};

export default ProgressBar;
